/* Dollars per point per contract, mirroring the backend's POINT_VALUES. Only used for live previews;
   unknown pairs are treated as spot units ($1 per point per unit). */
export const POINT_VALUES: Record<string, number> = { ES: 50, MES: 5, NQ: 20, MNQ: 2, YM: 5, MYM: 0.5, RTY: 50, M2K: 5, GC: 100, MGC: 10, CL: 1000, MCL: 100 };
